interface Props {
    title?: string;
    description?: string;
    iconColor?: string;
    parentStyle?: string;
}

export default function ErrorState({
    title = "Something went wrong",
    description = "We were unable to retrieve the requested information.",
    iconColor = "#dc2626",
    parentStyle = 'flex h-full w-full items-center justify-center px-6 py-8'
}: Props) {
    return (
        <div className={parentStyle}>
            <div className="flex w-full max-w-md flex-col items-center justify-center text-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-full border border-red-100 bg-red-50" style={{ color: iconColor }}>
                    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden="true">
                        <path d="M12 8v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M12 16h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </div>
                <div className="mt-4">
                    <p className="text-sm font-semibold text-gray-800">
                        {title}
                    </p>
                    <p className="mx-auto mt-0.5 max-w-sm text-xs leading-relaxed text-gray-500">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
}